import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {lazyRegister} from "@core/lazyRegister";
import {ProductStatusCode} from "@/models/ProductStatusCode";

export class ProductStatusCodeService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }
    GetAllStatusCodes(saleOrgId: number) {
        return this.baseApiFactory.getData<ProductStatusCode[]>('/api/ProductStatusCode/' + saleOrgId);
    };

    GetBySku(saleOrgId: number, sku: string, langCode: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<ProductStatusCode[]>(`/api/ProductStatusCode/${saleOrgId}/${sku}`, {langCode}, cancelToken);
    }
}

lazyRegister.service('ProductStatusCodeService', ProductStatusCodeService);
